import { LanguagePackageType } from "@/typeDefine/EntityType"
import companyImage2 from '@/assets/images/companyImage2.png'
import companyImage3 from '@/assets/images/companyImage3.jpg'

const Zh: LanguagePackageType = {
    index: {
        navBar: {
            home: '首页',
            aboutUs: '关于我们',
            product: '产品中心',
            news: '新闻',
            contactUs: '联系我们',
            newsDetails: '新闻详情',
            productDetails: '产品详情'
        },
        companyProfile: {
            title: '奥丁的全球合作',
            introduce: `奥丁电机公司创立于中国。经过20多年的发展，公司已成长为一家专业的小家电电机定制制造商。我们专注于小家电电机的研发、生产、安装调试及解决方案提供。主要产品包括交流电机、感应电机、直流电机、无刷电机等。我们的电机已成功出口到20多个国家和地区，并与多家公司建立了长期合作关系。欢迎加入我们或与我们展开合作。`
        },
        hotSales: {
            title: '热销产品',
            tips: '作为一家拥有二十多年电机经验的公司，我们为全球不同的客户提供各种产品。我们拥有自己的工厂，完整的生产线和工程师团队，致力于服务每一位客户，为客户提供高品质的产品。',
            lookMoreButtonText: '查看更多产品'
        },
        floatButton: {
            popoverTitle: '联系方式'
        },
        advantage: [
            {
                top: '20+',
                bottom: '多年经验'
            },
            {
                top: '15000+',
                bottom: '面积生产基地'
            },
            {
                top: '1000+',
                bottom: '企业员工'
            },
            {
                top: '100+',
                bottom: '合作客户'
            }
        ],
        chooseUs: {
            title: '为什么选择我们',
            tips: '',
            chooseItem: [
                {
                    title: '我们做什么？',
                    tips: `1.提供适用于电风扇、搅拌机、榨汁机、烤面包机、电动玩具、机器人等家用电器的电机。\n2.可根据要求定制各种电机、材料、功率、电压等。\n3.样品费在交易订单中作为折扣。`
                },
                {
                    title: '我们做得怎么样？',
                    tips: '1.四个工厂，包括 1500 多名工人，每年可以生产一千万的发动机数量。\n2.收到样品后，我们可以在7-15个工作日内提供产品进行测试。\n3.收到图纸后，我们可以在 7-15 个工作日内提供样品。'
                },
                {
                    title: '你能得到什么？',
                    tips: '1.美丽的价格和稳定的质量，产品始终与样品相同。\n2.快速的响应，专业的沟通。\n3.规定时间内最快交货，自有工厂，紧急时可以调整。'
                }
            ]
        },
        footer: {
            product: {
                title: '产品'
            },
            aboutUs: {
                title: '关于我们',
                item: [
                    {
                        path: '/aboutUs',
                        name: '关于我们'
                    }
                ]
            },
            contactUs: {
                title: '联系我们',
                item: [
                    {
                        path: '/contactUs',
                        name: '联系我们'
                    }
                ]
            },
            companyInfo: {
                title: '企业信息',
                item: [
                    '邮箱地址：lc@lcodin.com',
                    '联系电话：008618666465246',
                    '公司地址：中国深圳市光明新区高新路研祥工业园2号研发楼1206室'
                ],
            }
        }
    },
    aboutUs: {
        articleTitle: '全球家电电机制造商',
        articleContentList: [
            {
                h2Title: '',
                introduce: [
                    `奥丁以其系列电机和感应电机而闻名。奥丁位于中国深圳。20多年来，我们一直是高品质电机的主要出口商之一。经过多年的发展，我们已成为一家拥有完整生产流程的成熟电机制造商`
                ]
            },
            {
                h2Title: '关于奥丁',
                introduce: [
                    `奥丁进出口有限公司是一家集研发、生产和销售于一体的专业电机制造企业，致力于为客户提供多样化的电机产品和定制化服务。目前，公司专注于微型直流电机和交流串激电机的生产，产品广泛应用于家用电器、电动工具、医疗设备、通用机械、办公设备及自动化系统。我们的产品以稳定可靠的质量著称，性能指标符合国际标准，畅销全球，深受国内外客户的信赖与好评。未来，我们将持续追求技术进步，坚持卓越品质，秉持“服务至上”的理念，为客户创造更大价值。`,
                    `我们始终坚持的宗旨：高品质是我们的追求，客户满意是我们的承诺！`,
                ]
            }
        ],
        illustration: [
            {
                image: companyImage2,
                tips: '我们拥有智能化的生产设备，结合严格的质量管理体系，确保产品从原材料到成品的优良品质和稳定性。'
            },
            {
                image: companyImage3,
                tips: '图为我们的质检流程及核心部件生产线，每一道工序都经过专业工程师的精心设计、严格把控，这是我们履行对客户品质承诺的坚实保障。'
            }
        ]
    },
    contactUs: {
        title: '联系我们',
        contentList: [
            {
                h2Title: {
                    before: '总公司',
                    after: '深圳市奥丁进出口有限公司',
                },
                contactDetail: [
                    '地址：中国深圳市光明新区高新路研祥工业园2号研发楼1206室',
                    '电话：18666465246',
                    '邮箱：lc@lcodin.com',
                    '联系电话：0086-18666465246',
                    'WhatsApp: 86-18666465246',
                    '网址：www.lcodin.com'
                ]
            }
        ]
    },
    newsDetails: {
        views: '浏览',
        author: '作者',
        createTime: '发布时间',
    },
    products: {
        hotSales: '热销产品',
        lookMoreText: '查看更多',
        noProduct: '没有对应的的产品',
        describe: '描述'
    }
}

export default Zh